import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-[#2d3e50] last:border-b-0" data-id="element-13">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-6 text-left focus:outline-none focus:ring-2 focus:ring-[#a8b5d1]/30 rounded-lg px-2" aria-expanded={isOpen} data-id="element-14">
        <h3 className="text-xl md:text-2xl font-semibold text-[#e8edf4] pr-4" data-id="element-15">
          {question}
        </h3>
        <ChevronDownIcon className={`w-6 h-6 text-[#a8b5d1] flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-16" />
      </button>

      {isOpen && <div className="pb-6 px-2" data-id="element-17">
          <p className="text-lg text-[#d1d9e6] leading-relaxed" data-id="element-18">{answer}</p>
        </div>}
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'El protocolo está diseñado para 7 noches seguidas. Muchas mujeres reportan mejoras desde la primera noche, pero la clave es la repetición.'
  }, {
    question: '¿Necesito experiencia previa con meditación?',
    answer: 'No. Este no es un método de meditación tradicional. Es un protocolo paso a paso que cualquiera puede seguir.'
  }, {
    question: '¿Qué pasa si me despierto a las 3AM?',
    answer: 'El Plan de Emergencia 3AM está incluido específicamente para ese momento. Son 6 pasos simples que puedes seguir sin encender luces ni mirar el reloj.'
  }, {
    question: '¿Es esto terapia o tratamiento médico?',
    answer: 'No. Es un protocolo de autocuidado basado en técnicas de regulación nerviosa. Si tienes una condición médica, consulta con tu profesional de salud.'
  }];
  return <section className="w-full bg-[#1a1f2e] py-16 md:py-24 px-4" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-12 text-center" data-id="element-21">
          Preguntas Frecuentes
        </h2>

        <div className="bg-[#1e2738] rounded-2xl p-8 md:p-12 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-22">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-23" />)}
        </div>
      </div>
    </section>;
}